// News page filtering (progressive enhancement) + "copy link" on single posts.
// Without JS the toolbar is a normal GET form and every pill/page is a real link.

export default function initBlog() {
	initCopyLink()

	var root = document.querySelector('[data-blog]')
	var form = root && root.querySelector('[data-blog-form]')
	if (!form) return

	function buildUrl() {
		var url = new URL(form.action, window.location.href)
		var data = new FormData(form)
		data.forEach(function (value, key) {
			value = String(value).trim()
			if (value) url.searchParams.set(key, value)
		})
		return url.toString()
	}

	root.classList.add('is-enhanced')

	// Archive pages (category/date) and older browsers: full page loads to /news/ with clean URLs.
	var canFetch = window.fetch && window.DOMParser && window.history.pushState
	if (root.hasAttribute('data-blog-static') || !canFetch) {
		form.addEventListener('submit', function (e) {
			e.preventDefault()
			window.location.href = buildUrl()
		})
		form.addEventListener('change', function (e) {
			if (e.target.hasAttribute('data-blog-autosubmit')) window.location.href = buildUrl()
		})
		return
	}

	var results = root.querySelector('[data-blog-results]')
	var topics = root.querySelector('[data-blog-topics]')
	var topicInput = form.querySelector('[data-blog-topic]')
	var searchInput = form.querySelector('[data-blog-search]')
	var requestId = 0
	var searchTimer = null
	var lastSearch = searchInput ? searchInput.value : ''

	function syncControls(doc) {
		var nextForm = doc.querySelector('[data-blog-form]')
		if (!nextForm) return
		Array.prototype.forEach.call(nextForm.elements, function (el) {
			if (!el.name) return
			var current = form.elements[el.name]
			if (!current || current === document.activeElement) return
			current.value = el.value
		})
		if (searchInput) lastSearch = searchInput.value
	}

	function navigate(url, options) {
		options = options || {}
		var id = ++requestId
		root.classList.add('is-loading')
		results.setAttribute('aria-busy', 'true')

		fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'fetch' } })
			.then(function (res) {
				if (!res.ok) throw new Error(res.status)
				return res.text()
			})
			.then(function (html) {
				if (id !== requestId) return
				var doc = new DOMParser().parseFromString(html, 'text/html')
				var nextResults = doc.querySelector('[data-blog-results]')
				var nextTopics = doc.querySelector('[data-blog-topics]')
				if (!nextResults) throw new Error('No results region')

				results.innerHTML = nextResults.innerHTML
				if (nextTopics && topics) topics.innerHTML = nextTopics.innerHTML
				syncControls(doc)

				if (options.push !== false) window.history.pushState({ blog: true }, '', url)
				if (options.scroll) scrollToTop()
			})
			.catch(function () {
				window.location.href = url
			})
			.then(function () {
				if (id !== requestId) return
				root.classList.remove('is-loading')
				results.removeAttribute('aria-busy')
			})
	}

	function scrollToTop() {
		var nav = document.querySelector('.navbar-wrap')
		var offset = nav ? nav.offsetHeight + 16 : 120
		var top = form.getBoundingClientRect().top + window.pageYOffset - offset
		if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' })
	}

	function submit() {
		clearTimeout(searchTimer)
		if (searchInput) lastSearch = searchInput.value
		navigate(buildUrl())
	}

	form.addEventListener('submit', function (e) {
		e.preventDefault()
		submit()
	})

	form.addEventListener('change', function (e) {
		if (e.target.hasAttribute('data-blog-autosubmit')) submit()
	})

	if (searchInput) {
		searchInput.addEventListener('input', function () {
			clearTimeout(searchTimer)
			searchTimer = setTimeout(function () {
				if (searchInput.value.trim() !== lastSearch.trim()) submit()
			}, 450)
		})
	}

	root.addEventListener('click', function (e) {
		if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return

		var pill = e.target.closest('[data-blog-topics] [data-topic]')
		if (pill) {
			e.preventDefault()
			topicInput.value = pill.getAttribute('data-topic')
			submit()
			return
		}

		var clear = e.target.closest('[data-blog-clear]')
		if (clear) {
			e.preventDefault()
			form.reset()
			Array.prototype.forEach.call(form.elements, function (el) {
				if (el.name) el.value = ''
			})
			submit()
			return
		}

		var pageLink = e.target.closest('.blog-pagination a')
		if (pageLink) {
			e.preventDefault()
			navigate(pageLink.href, { scroll: true })
		}
	})

	window.history.replaceState({ blog: true }, '', window.location.href)
	window.addEventListener('popstate', function (e) {
		if (e.state && e.state.blog) navigate(window.location.href, { push: false })
	})
}

function initCopyLink() {
	var buttons = document.querySelectorAll('[data-copy-url]')
	Array.prototype.forEach.call(buttons, function (btn) {
		btn.addEventListener('click', function () {
			var url = btn.getAttribute('data-copy-url')
			var label = btn.textContent
			var done = function () {
				btn.textContent = 'Link copied'
				setTimeout(function () {
					btn.textContent = label
				}, 2000)
			}
			if (navigator.clipboard) {
				navigator.clipboard.writeText(url).then(done, function () {
					window.prompt('Copy this link:', url)
				})
			} else {
				window.prompt('Copy this link:', url)
			}
		})
	})
}
